var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};
$(window).resize(function() {
    owlCarouselInResponsive()
})
$(document).ready(function () {
    owlCarouselInResponsive();
});
function owlCarouselInResponsive() {
    $(window).width() <= 768 ? $(".areas").each(function() {
        $(this).owlCarousel({
            loop: !1,
            autoplay: !0,
            nav: !0,
            nav: false,
            dots:true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive: {
                0: {
                    items: 1
                },
				768: {
                    items: 2
                },
                992: {
                    items: 3
                }
            }
        })
    }) : $(".areas").each(function() {
        var a = $(this).data("owlCarousel");
        a && (a.destroy(), $(this).removeClass("owl-carousel owl-loaded"), $(this).find(".owl-stage-outer").children().unwrap())
    })
}
var $ = jQuery.noConflict();
	$(document).ready(function(){
		$(function () {
		    $('.selectpicker').selectpicker();
		    $(".dropdown-toggle").dropdown();
		});	
		
		$(window).scroll(function(){
	        backToTop()
	    })
	    $(document).ready(function(){
	        backToTop()
	        $(".back-top").click(function(){
	            $("html,body").animate({scrollTop:0},1200)
	        })
	    })
	    function backToTop(){
	        if($(window).scrollTop() > 150){
	           $(".back-top").fadeIn()
	        } else {
	            $(".back-top").fadeOut()
	        }
	    }
	    $(function() {
	      $('.footer-nav h3').on('click', function() {
			  let $li = $(this).parent().toggleClass('is-open');
			  $('.footer-nav').not($li).removeClass('is-open');
			});
	    });
	    $(function() {
	      $('.mega-title').on('click', function() {
			  let $li = $(this).parent().toggleClass('is-active');
			  $('.link-list-nav').not($li).removeClass('is-active');
			});
	    });
	    

		$('.dropdown-menu').click(function(e) {
		    e.stopPropagation();
		});
	    
	    
	});

     $(document).on('click', '.ajax-cart-item__minus-quantity', function(e){
       var pid = $(this).attr('data-product-id');
       decrementValue(e,pid);
     });
     $(document).on('click', '.ajax-cart-item__add-quantity', function(e){
       var pid = $(this).attr('data-product-id');
       incrementValue(e,pid);
     });
function incrementValue(e,pid) {   
  e.preventDefault();  
  //console.log(pid);
  var currentVal = parseInt($('.product_'+pid+' .ajax-cart-item__input-quantity').val(), 10);
 

  if (!isNaN(currentVal)) {
    $('.product_'+pid+' .ajax-cart-item__input-quantity').val(currentVal +1);    
  } else {
    $('.product_'+pid+' .ajax-cart-item__input-quantity').val(1);    
  }
   console.log("value now is "+currentVal)
  selectqtytable(currentVal);
}
function decrementValue(e,pid) {
  e.preventDefault();  
  //console.log(pid);
  console.log("Decrement value");
  var currentVal = parseInt($('.product_'+pid+' .ajax-cart-item__input-quantity').val(), 10);  
  if (!isNaN(currentVal) && currentVal > 1) {
    $('.product_'+pid+' .ajax-cart-item__input-quantity').val(currentVal - 1);    
  } else {
    $('.product_'+pid+' .ajax-cart-item__input-quantity').val(1);    
  }
  selectqtytabledec(currentVal);
}
function selectqtytabledec(currentVal)
{    
  console.log(currentVal);
  $('.quality-filter').filter(':checked').prop('checked', false);
  console.log($('.quality-filter').filter(':checked').attr("id"));
  console.log($(".quality-filter:checked").attr("id"));
        
    
  if(currentVal>0 &&  currentVal <= 4)
  {
    console.log("in first");
    $('#quality-select').prop("checked", true); 
    $('#ppfilter').val($('#qty1').text());
    $('#ppfilter_pp').text($('#qty1').text());
  }
  if(currentVal > 4 && currentVal <= 6)
  {
    console.log("in second");
    $('#quality-select1').prop("checked", true); 
    $('#ppfilter').val($('#qty4').text());
    $('#ppfilter_pp').text($('#qty4').text());
  }
  if(currentVal > 6 && currentVal <= 12)
  {
    console.log("IN THIRD "+currentVal);
    $('#quality-select2').prop("checked", true); 
    //alert($('#qty6').text());
    $('#ppfilter').val($('#qty6').text());
    $('#ppfilter_pp').text($('#qty6').text());    
  }
  if(currentVal >12 && currentVal <=48 )
  {
    $('#quality-select3').prop("checked", true); 
    $('#ppfilter').val($('#qty12').text());
    $('#ppfilter_pp').text($('#qty12').text());
  }
  if(currentVal > 48 && currentVal <= 72)
  {
    $('#quality-select4').prop("checked", true); 
    $('#ppfilter').val($('#qty48').text());
    $('#ppfilter_pp').text($('#qty48').text());
  }
  if(currentVal > 72 && currentVal <= 120)
  {
    $('#quality-select5').prop("checked", true); 
    $('#ppfilter').val($('#qty72').text());
    $('#ppfilter_pp').text($('#qty72').text());
  }
  if(currentVal > 120 )
  {
    $('#quality-select6').prop("checked", true); 
    $('#ppfilter').val($('#qty120').text());
    $('#ppfilter_pp').text($('#qty120').text());
  }
  var label=$('input[name="quality-filter"]:checked').val();
  console.log(label);
  var saved=$("label[for="+label+"] .t-price").html();
  $("#save-heading").text("SAVING "+saved)
  var each=$("label[for="+label+"] small").html();
  console.log(each)
  $("#per-price").html(each);
 
  var per=$("#qty1").text();
  per=Number(per.replace(/[^0-9.-]+/g,""));
  each=Number(each.replace(/[^0-9.-]+/g,""));
   currentVal=currentVal+1;
  var total=per*currentVal;
  total=total.toFixed(2);
  var discounted=each*currentVal;
  discounted=discounted.toFixed(2);
  var sv=total-discounted;
  sv=sv.toFixed(2);
   $(".you-saved").html("you saved $"+sv);
 
  $(".orignal-p").text("$"+total);
  $(".discounted-p").text("$"+discounted);
}
$("input[name='quality-filter']").change(function() {
  var label=$('input[name="quality-filter"]:checked').val();
  var currentVal=$("label[for="+label+"] span:not(.t-price)").html();
  currentVal=Number(currentVal.replace(/[^0-9.-]+/g,""));
 
  $("input[name='quantity'").val(currentVal);
 
  var buttonVal = $("input[name='quality-filter']:checked").val();
  var per=$("#qty1").text();
  
  console.log(label);
  var saved=$("label[for="+label+"] .t-price").html();
  $("#save-heading").text("SAVING "+saved)
  var each=$("label[for="+label+"] small").html();
  
  console.log(each)
  $("#per-price").html(each);
 
  var per=$("#qty1").text();
  per=Number(per.replace(/[^0-9.-]+/g,""));
  each=Number(each.replace(/[^0-9.-]+/g,""));
   
  var total=per*currentVal;
  total=total.toFixed(2);
  var discounted=each*currentVal;
  discounted=discounted.toFixed(2);
  var sv=total-discounted;
  sv=sv.toFixed(2);
   $(".you-saved").html("you saved $"+sv);
 
  $(".orignal-p").text("$"+total);
  $(".discounted-p").text("$"+discounted);
 
    
})


function selectqtytable(currentVal)
{    
   $('.quality-filter').prop("checked", false); 
 if(currentVal>0 &&  currentVal < 3)
  {
    console.log("in first");
    $('#quality-select').prop("checked", true); 
    $('#ppfilter').val($('#qty1').text());
    $('#ppfilter_pp').text($('#qty1').text());
  }
  if(currentVal >= 3 && currentVal < 5)
  {
    console.log("in second");
    $('#quality-select1').prop("checked", true); 
    $('#ppfilter').val($('#qty4').text());
    $('#ppfilter_pp').text($('#qty4').text());
  }
  if(currentVal >= 5 && currentVal < 11)
  {
    $('#quality-select2').prop("checked", true); 
    //alert($('#qty6').text());
    $('#ppfilter').val($('#qty6').text());
    $('#ppfilter_pp').text($('#qty6').text());    
  }
  if(currentVal >= 11 && currentVal < 48)
  {
    $('#quality-select3').prop("checked", true); 
    $('#ppfilter').val($('#qty12').text());
    $('#ppfilter_pp').text($('#qty12').text());
  }
  if(currentVal >= 47 && currentVal < 72)
  {
    $('#quality-select4').prop("checked", true); 
    $('#ppfilter').val($('#qty48').text());
    $('#ppfilter_pp').text($('#qty48').text());
  }
  if(currentVal >= 71 && currentVal < 120)
  {
    $('#quality-select5').prop("checked", true); 
    $('#ppfilter').val($('#qty72').text());
    $('#ppfilter_pp').text($('#qty72').text());
  }
  if(currentVal >= 119 )
  {
    $('#quality-select6').prop("checked", true); 
    $('#ppfilter').val($('#qty120').text());
    $('#ppfilter_pp').text($('#qty120').text());
  }
  var label=$('input[name="quality-filter"]:checked').val();
  var saved=$("label[for="+label+"] .t-price").html();
  $("#save-heading").text("SAVING "+saved)
  var each=$("label[for="+label+"] small").html();
  $("#per-price").html(each);
 
  var per=$("#qty1").text();
  per=Number(per.replace(/[^0-9.-]+/g,""));
  each=Number(each.replace(/[^0-9.-]+/g,""));
   currentVal=currentVal+1;
  var total=per*currentVal;
  total=total.toFixed(2);
  var discounted=each*currentVal;
  discounted=discounted.toFixed(2);
  var sv=total-discounted;
  sv=sv.toFixed(2);
   $(".you-saved").html("you saved $"+sv);
 
  $(".orignal-p").text("$"+total);
  $(".discounted-p").text("$"+discounted);
}
//This function check if number n is between a and b
function isBetween(n, a, b) {
  console.log("between "+a+" and "+b);
   return (n - a) * (n - b) <= 0
}
$(document).ready(function(){
    $('.main-form-control').on('change', function() {
      console.log("world...")
      var width = parseInt($('#pa_width-feet').val());
      //alert(width);
      var widthin = 1;//$('#pa_width-inches').val();
      var length = parseInt($('#pa_length-feet').val());
      //alert(length);
      var lengthin = 1;//$('#pa_length-inches').val();
      var depth = parseInt($('#pa_depth').val());
      //alert(depth);
      var performance = $('input[name="perfomance"]:checked').val();
      var counter = (width * length * depth);
      var myprice = 0 ;
      var check=false;
  
      if(length>0 && width>0 && depth>0 )
      {
          for(var j=100;j<10000;j=j+100) {
                 
            var nextval=parseInt(j+99);
            console.log(j+" "+nextval)
             console.log($('#'+performance+'_'+j+'-'+nextval))
              console.log($('#'+performance+'_'+j+'-'+nextval).val())
            console.log(counter)
            if(isBetween(counter,j,nextval))
            {
              check=true;
             console.log("true for "+j+" "+nextval)
              var myvid = $('#'+performance+'_'+j+'-'+nextval).val();
              var myprice = $('#'+performance+'_'+j+'-'+nextval).data('price-value');
              console.log('#'+performance+'_'+j+'-'+nextval)
              console.log("price "+myprice)
              break;
            } else 
            {
             
            }
          }
        /*
        if(performance == 'M11')
        {
          var myvid = $('#M11_100-199').val();
          var myprice = $('#M11_100-199').data('price-value');
          
        }
        if(performance == 'M13')
        {
          var myvid = $('#M13_100-199').val();
          var myprice = $('#M13_100-199').data('price-value');
        } 
        */
        console.log("performance is "+performance)
      }

      if(length>0 && width>0 && depth>0 ) {
        console.log("My priice is my "+myprice)
        if(myprice==undefined || myprice==0) {
        alert("Variant not available");
        $('#pa_width-feet').val('');
        $('#pa_width-feet').val('');
        $('#ppfilter').val('$0.00');
        
        $('#pa_depth').val('');
        $(".filter-option-inner-inner").text("Option");
        return;
        }
      } else {
        console.log("Not set")
      }
      
      $('#mycustomform_id').val(myvid);
      $('#mycustomform_qty').val($('#quantity_9372573991204').val());
      $('#width').val($('#pa_width-feet').val());
      $('#widthi').val($('#pa_width-inches').val());
      $('#length').val($('#pa_length-feet').val());
      $('#lengthi').val($('#pa_length-inches').val());
      $('#depth').val($('#pa_depth').val());      
      
      $('#ppfilter').val(Shopify.formatMoney(myprice, '${{amount}}'));      
      $('#qty4').text(Shopify.formatMoney(myprice, '${{amount}}'));
      var qty6 = (myprice - (myprice * 0.10));
      $('#qty6').text(Shopify.formatMoney(qty6, '${{amount}}'));
      var qty12 = (myprice - (myprice * 0.12));
      $('#qty12').text(Shopify.formatMoney(qty12, '${{amount}}'));
      var qty48 = (myprice - (myprice * 0.15));
      $('#qty48').text(Shopify.formatMoney(qty48, '${{amount}}'));
      var qty72 = (myprice - (myprice * 0.25));
      $('#qty72').text(Shopify.formatMoney(qty72, '${{amount}}'));
      var qty120 = (myprice - (myprice * 0.30));
      $('#qty120').text(Shopify.formatMoney(qty120, '${{amount}}'));
       
    });   
  $(document).on("click","#customaddtocart",function() {
        addProductToCart('mycustomform');
    });
  $(document).on("click",".cartupdateqty",function() {
        var lineitem = $(this).attr('data-line-item');
        var vid = $(this).attr('data-product-id');
        var qty = $('#quantity_'+vid).val();
        changeItemcustom(lineitem,qty);
  });
  $(document).on("click",".cartupdateqty",function() {
        var lineitem = $(this).attr('data-line-item');
        var vid = $(this).attr('data-product-id');
        var qty = $('#quantity_'+vid).val();
        changeItemcustom(lineitem,qty);
  });
  $('.ajax-cart-item__input-quantity').on('change', function() {
    var cval = $(this).val();
    selectqtytable(cval);
  });
  $('.customcartinput').on('change', function() {
      var lineitem = $(this).attr('data-line-item');
      var vid = $(this).attr('data-product-id');
      var qty = $('#quantity_'+vid).val();
      changeItemcustom(lineitem,qty);
  });
  
});
(function() {
    var owl = $('.owl-carousel'),
        owlOptions = {
          loop: false,
			    margin: 30,
			    smartSpeed: 700,
			    nav: false,
			    items: 1
        };

    if ( $(window).width() < 768 ) {     
        var owlActive = owl.owlCarousel(owlOptions);
    } else {
        owl.addClass('off');
    }

    $(window).resize(function() {
        if ( $(window).width() < 768 ) {
            if ( $('.owl-carousel').hasClass('off') ) {
                var owlActive = owl.owlCarousel(owlOptions);
                owl.removeClass('off');
            }
        } else {
            if ( !$('.owl-carousel').hasClass('off') ) {
                owl.addClass('off').trigger('destroy.owl.carousel');
                owl.find('.owl-stage-outer').children(':eq(0)').unwrap();
            }
        }
    });
});
$(document).ready(function () {
  $(".filterhomedepth").change(function() {
    var $option = $(this).find(':selected');
    var url = $option.val();
    window.location.href = '/collections/all?filter.p.m.custom.filter_size='+url;
  });
  /*$('.owl-carousel').owlCarousel({
    loop:true,
    margin:0,
    nav:false,
    dots:false,
    responsive:{
        0:{
            items:2
        },
        600:{
            items:2
        },
        1000:{
            items:5
        }
    }
})*/
});